import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { OpponentsApiService } from 'src/app/core/services/api/opponents-api.service';
import { CaseOpponent } from '../models/cases/caseOpponent';
import { NgSelectProps } from '../models/ng-select-props';

@Component({
  selector: 'app-create-edit-opponent',
  templateUrl: './create-edit-opponent.component.html',
  styleUrls: ['./create-edit-opponent.component.scss']
})
export class CreateEditCaseOpponentComponent implements OnInit {

  opponent: CaseOpponent;
  modalRef: NgbModalRef;

  opponentNgSelect: NgSelectProps = null;
  descriptionNgSelect: NgSelectProps = null;

  @Output('submitOpponent') submitOpponent: EventEmitter<CaseOpponent> = new EventEmitter();
  @ViewChild('opponentModal') opponentModal;
  constructor(
    private opponentsApi: OpponentsApiService,
    private modalService: NgbModal,
    private filesApi: FilesApiService,

  ) { }

  ngOnInit(): void {
    this.opponentNgSelect = new NgSelectProps(this.opponentsApi.getOpponents);
    this.descriptionNgSelect = new NgSelectProps(this.filesApi.getDescriptions);
  }
  open(opponent: CaseOpponent) {
    this.opponent = Object.assign(new CaseOpponent(), opponent);
    this.modalRef = this.modalService.open(this.opponentModal, {
      keyboard: false,
      size: 'sm',
      centered: true
    });
  }

  onSubmit() {
    // console.log(this.opponent);
    this.opponent.opponentId = this.opponent.opponent.id;
    this.opponent.descriptionId = this.opponent.description.id;
    this.submitOpponent.emit(this.opponent);
    this.modalRef.close();
  }

  searchFn() {
    return true;
  }

}